import { FC, ReactNode } from "react";
import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BusinessIcon, ChartOfAccountsIcon } from "@icons";
import styles from "../AddClientDrawerSteps.module.scss";

interface CoaSetupTileProps {
    icon: ReactNode;
    title: string;
    description: string;
    isDisabled?: boolean;
    disabledTooltip?: string;
    onSelect: () => void;
}

const CoaSetupTile: FC<CoaSetupTileProps> = ({
    icon,
    title,
    description,
    isDisabled = false,
    disabledTooltip,
    onSelect,
}) => (
    <Tooltip content={disabledTooltip} disabled={!isDisabled}>
        <div
            className={classNames(styles.kickOption, {
                [styles.kickOptionDisabled]: isDisabled,
            })}
            onClick={isDisabled ? undefined : onSelect}
            role="button"
            aria-disabled={isDisabled}
        >
            <div className={styles.kickOptionContent}>
                <div className={styles.kickOptionIcon}>{icon}</div>
                <div className={styles.kickOptionTexts}>
                    <div className={styles.kickOptionTitle}>{title}</div>
                    <div className={styles.kickOptionDescription}>
                        {description}
                    </div>
                </div>
            </div>
        </div>
    </Tooltip>
);

interface Props {
    isTemplateTileVisible: boolean;
    areTemplatesFetched: boolean;
    hasTemplates: boolean;
    isEntityTileVisible: boolean;
    areCopySourcesFetched: boolean;
    onSelectTemplate: () => void;
    onSelectEntity: () => void;
}

export const CoaSetupTiles: FC<Props> = ({
    isTemplateTileVisible,
    areTemplatesFetched,
    hasTemplates,
    isEntityTileVisible,
    areCopySourcesFetched,
    onSelectTemplate,
    onSelectEntity,
}) => (
    <>
        {isTemplateTileVisible && (
            <CoaSetupTile
                icon={<ChartOfAccountsIcon />}
                title="Use a template"
                description="Start from one of your firm's templates"
                isDisabled={
                    !areCopySourcesFetched ||
                    !areTemplatesFetched ||
                    !hasTemplates
                }
                disabledTooltip={
                    areTemplatesFetched && areCopySourcesFetched
                        ? "Your firm has no Chart of Accounts templates yet"
                        : "Loading…"
                }
                onSelect={onSelectTemplate}
            />
        )}
        {isEntityTileVisible && (
            <CoaSetupTile
                icon={<BusinessIcon />}
                title="Copy from entity"
                description="Copy the Chart of Accounts from another entity of this client"
                isDisabled={!areCopySourcesFetched}
                disabledTooltip="Loading entities…"
                onSelect={onSelectEntity}
            />
        )}
    </>
);
